import { fromJS, List, Record } from 'immutable';
import { endsWith } from 'lodash';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../utils/helpers/model.helper';
import { BannerCanvasTypesEnum } from '../features-data.data';
import { Banner } from './banner.model';
import { Canvas } from './canvas.model';
import { PageCtas } from './page-ctas.model';

export const BANNERS_CANVASES_SCHEMA = Object.freeze({
  BANNERS: List<Banner>([]),
  CANVASES: List<Canvas>([]),
  PAGE_CTAS: PageCtas,
});

const RECORD = generateSchema(BANNERS_CANVASES_SCHEMA);
const KEYS: any = generateKeys(BANNERS_CANVASES_SCHEMA);

export class BannersCanvases extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    const selfModel = setInModel(this, [
      {
        key: KEYS.BANNERS,
        value: props.get(KEYS.BANNERS)
          ? this.banners.map((params) => new Banner(params))
          : List<Banner>([]),
      },
      {
        key: KEYS.CANVASES,
        value: props.get(KEYS.CANVASES)
          ? this.canvases.map((params) => new Canvas(params))
          : List<Canvas>([]),
      },
      {
        key: KEYS.PAGE_CTAS,
        value: new PageCtas(this.pageCtas),
      },
    ]);

    return selfModel as BannersCanvases;
  }

  get banners(): List<Banner> {
    return this.get(KEYS.BANNERS);
  }

  get canvases(): List<Canvas> {
    return this.get(KEYS.CANVASES);
  }

  get pageCtas(): PageCtas {
    return this.get(KEYS.PAGE_CTAS);
  }

  hasFeatureHighlightCanvas(featureName: string): boolean {
    return !!this.canvases.find(
      (canvas: Canvas) =>
        canvas.type === BannerCanvasTypesEnum.feature_highlight &&
        endsWith(canvas.name, featureName)
    );
  }
}
